import { Text, TextStyle, View } from "react-native"
import { capitalize } from "../../../../lib/generique";
import {  useCallback, useMemo, useRef, useState } from "react";
import { ToolbarProps, Views } from "react-big-calendar";
import { EventType } from "../../../../api/DemandeAbsence/types";
import dayjs from 'dayjs'
import { createPortal } from 'react-dom';
import { useResponsive } from "../../../../hooks";
import styles from "../../CalendrierUniversel.styles";
import DateTimePicker, { DateTimePickerEvent } from "../../../DateTimePickerWrapper";
type Props = {
    label: string,
    titleStyle: TextStyle,
}

export default function FragmentToolbarDate(props: ToolbarProps<EventType> & Props){
    const {date, label, titleStyle, onNavigate, onView} = props
    const isResponsive = useResponsive();
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const inputRef = useRef<any>(null);
    const inputDescription = inputRef.current?.getBoundingClientRect();

    const errorStyle = useMemo<TextStyle>(() => ({
        position: 'absolute',
        textAlign: 'center',
        left: (inputDescription?.left || 0) - 20,
        top: (inputDescription?.top || 0) - 40,
        width: inputDescription?.width + 40,
        padding: 4,
        backgroundColor: 'white',
        borderColor: 'red',
        borderWidth: 1,
        borderRadius: 5,
        color: 'red',
        zIndex: 99999,
    }), [inputDescription])

    const [search, setSearch] = useState('');
    const [error, setError] = useState('');

    const toggleDatePicker = useCallback(() => {
        if(isResponsive){
            setDatePickerOpen((old) => !old);
        }
    }, [isResponsive])

    const handleType = useCallback((event: any) => {
        let saisie: string = event.target.value;
        if(!saisie.match(/[^0-9/]/)){
            setError('')
            if(saisie.length === search.length - 1){
                if(search.charAt(saisie.length) === '/'){
                    saisie = saisie.slice(0, -1);
                }
            } else if(saisie.length === 2 || saisie.length === 5){
                saisie += '/'
            }
            setSearch(saisie);
        } else {
            setError('Caractère invalide');
        }
    }, [search])

    const handleValidate = useCallback(() => {
        if(search.length === 10) {
            onNavigate("DATE", dayjs(search.split('/').toReversed().join('-')).toDate());
            onView(Views.DAY);
        } else {
            setError('Saisie incomplète');
        }
    }, [onNavigate, onView, search])

    const handleKeyDown = useCallback((event: any) => {
        if(event.key === "Enter"){
            handleValidate();
        }
    }, [handleValidate])

    const handleValidatePicker = useCallback((_: DateTimePickerEvent, newDate?: Date) => {
        onNavigate("DATE", newDate);
        onView(Views.DAY);
        toggleDatePicker();
    }, [onNavigate, onView, toggleDatePicker])

    return (
        <View style={styles.dateContainer}>
            <Text style={titleStyle} onPress={toggleDatePicker}>{capitalize(label)}</Text>
            {error !== '' && createPortal(
                <Text style={errorStyle}>{error}</Text>,
                document.body
            )}
            { isResponsive ?(
                <>
                    {datePickerOpen && (
                        <DateTimePicker value={date} onChange={handleValidatePicker} />
                    )}
                </>
            )
             : (
                <View style={styles.inputContainer}>
                    <input
                        ref={inputRef}
                        type="text"
                        pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
                        placeholder="jj/mm/aaaa"
                        value={search}
                        style={styles.input}
                        maxLength={10}
                        onChange={handleType}
                        onKeyDown={handleKeyDown}
                    />
                </View>
            )}
        </View>
    )
}
